<template>
  <div class="login-container">
    <div class="login-card">
      <div class="card-login-img">
        
      </div>
      <div class="logout-form">
        登出中...
      </div>
    </div>
  </div>
</template>
<script>
import { getVerifyCode } from '@/api/user';
import Language from "@/components/Languagev";

export default {
  components: {
    Language
  },
  data() {
   
  },
  created() {
    //this.rules = ;
    this.logout();
  },
  methods: {
    async logout() {
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login`)
    }
  }
}
</script>
<style scoped lang="scss">
.login-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  background: url('../assets/bg_login.png') no-repeat;
  background-size: cover;
  background-color: #22B0FF;
}

.login-card {
  width: 1140px;
  height: 590px;
  background-color: #fff;
  border-radius: 10px;
  display: flex;

  .card-login-img {
    width: 609px;
    height: 692px;
    margin-top: -50px;
    margin-left: 25px;
  }

  .logout-form
  {
    color:#2078FA;
    position:fixed;
    left: 50%;
    top:50%;
    transform: translate(-50%,-50%);
    font-size: 50px;
  }
}

.code-form-item {
  display: flex;

  .code-img {
    width: 130px;
    height: 40px;
    margin-left: 10px;
    cursor: pointer;
  }
}

.login-btn {
  width: 100%;
  height: 52px;
  background: linear-gradient(90deg, #2078FA, #59C1FD);
  border-radius: 100px;
  text-align: center;
  line-height: 52px;
  color: #fff;
  letter-spacing: 8px;
  font-size: 18px;
  margin-top: 30px;
  cursor: pointer;

  &:active {
    opacity: 0.9;
  }
}

img {
  width: 100%;
  height: 100%;
}
</style>

<style scoped>
.input>>>.el-input__inner {
  border-radius: 40px;
  padding-left: 50px;
}

.input>>>.el-input__prefix {
  top: 2px;
}

.input>>>.el-input__suffix {
  right: 14px;
  top: 3px;
}
</style>
